/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import PropTypes from 'prop-types'
import React from 'react'
import Helmet from 'react-helmet'
import {DEFAULT_SITE_TITLE} from '../../constants'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

const Seo = ({title, description, noIndex, children, ...props}) => {
    const fullTitle = title
        ? `${title} | ${DEFAULT_SITE_TITLE}`
        : DEFAULT_SITE_TITLE

    return (
        <Helmet {...props}>
            <title>{fullTitle}</title>
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link
                rel="preconnect"
                href="https://fonts.gstatic.com"
                crossOrigin="true"
            />
            <link
                href="https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100..900;1,100..900&display=swap"
                rel="stylesheet"
            ></link>

            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link
                rel="preconnect"
                href="https://fonts.gstatic.com"
                crossOrigin="true"
            />
            <link
                href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap"
                rel="stylesheet"
            ></link>

            <title>
                Rennaï: Your Self-Care & Beauty Boutique in Montréal, Canada |
                Rennaï
            </title>
            <meta
                name="description"
                content="Rennaï is your ultimate self-care and beauty boutique in Montréal. Discover premium skincare, wellness products, and luxury beauty essentials tailored for your unique needs."
            />

            <meta property="og:url" content="https://www.rennai.com" />
            <meta property="og:type" content="website" />
            <meta
                property="og:title"
                content="Rennaï: Your Self-Care & Beauty Boutique in Montréal, Canada | Rennaï"
            />
            <meta
                property="og:description"
                content="Discover Rennaï, Montréal's top destination for self-care and beauty. Browse our exclusive range of luxury skincare, wellness products, and more for your ultimate self-care experience."
            />
            <meta
                property="og:image"
                content="https://images.ctfassets.net/v0rdkyiyx25c/2owwXvAfOLlnQnGWP8Amg4/f8d2e23924bc3f3beab99bed49d6df16/Rennai_Logo1.png"
            />

            <meta name="twitter:card" content="summary_large_image" />
            <meta property="twitter:domain" content="www.rennai.com" />
            <meta property="twitter:url" content="https://www.rennai.com" />
            <meta
                name="twitter:title"
                content="Rennaï: Your Self-Care & Beauty Boutique in Montréal, Canada | Rennaï"
            />
            <meta
                name="twitter:description"
                content="Explore Rennaï, your premier destination for self-care and beauty products in Montréal. Discover a curated selection of luxury skincare, wellness, and more."
            />
            <meta
                name="twitter:image"
                content="https://images.ctfassets.net/v0rdkyiyx25c/2owwXvAfOLlnQnGWP8Amg4/f8d2e23924bc3f3beab99bed49d6df16/Rennai_Logo1.png"
            ></meta>
            {description && <meta name="description" content={description} />}
            {noIndex && <meta name="robots" content="noindex" />}
            {children}
        </Helmet>
    )
}

Seo.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    noIndex: PropTypes.bool,
    children: PropTypes.node
}

export default Seo
